const prefix = 'horizontal-scroll';
export const dataHooks = {
    leftButton: `${prefix}-left-button`,
    rightButton: `${prefix}-right-button`,
    scrollContainer: `${prefix}-scroll-container`,
};
//# sourceMappingURL=HorizontalScroll.constants.js.map